module.exports = __webpack_public_path__ + "static/media/sjs.073c2320.svg";